import request from '@/utils/request'

export function getMitmdtlpList(itmcd, itmdtlcd) {
  return request({
    url: `/api/mitmdtlpList/query`,
    method: 'get',
    params: { itmcd: itmcd, itmdtlcd: itmdtlcd },
  })
}

export function getmitmdtlp(itmcd, itmdtlcd) {
  return request({
    url: `/api/mitmdtlp/${itmcd}/${itmdtlcd}`,
    method: 'get',
  })
}
